export default {
  SET_LOADING(state, status) {
    state.loading = status;
  },

  SET_CATEGORIES(state, data) {
    state.categories = data;
  },

  SET_COMPANY_PROFILE(state, companyProfile) {
    state.data = companyProfile;
  },

  SET_COMPANY_ID(state, id) {
    state.id = id;
  },

  SET_COMPANY(state, company) {
    state.company = company ? { ...company } : null;
  },

  SET_PARENT(state, parentCompany) {
    state.parent = parentCompany;
  },

  SET_COMPANIES(state, companies) {
    state.companies = [...companies];
  },

  SET_COMPANY_SOCIAL_MEDIA(state, { facebook, instagram }) {
    state.form.facebookProfile = facebook;
    state.form.instagramProfile = instagram;
  },

  UPDATE_FORM_WEBSITE_URL(state, value) {
    state.form.websiteUrl = value;
  },

  UPDATE_FORM_FACEBOOK_PROFILE(state, value) {
    state.form.facebookProfile = value;
  },

  UPDATE_FORM_INSTAGRAM_PROFILE(state, value) {
    state.form.instagramProfile = value;
  },

  SET_WIZARD_COMPLETION_STATUS(state, status) {
    state.isWizardCompleted = status;
  }
};
